import {defineMessages} from "react-intl";

export default defineMessages({  
  addATag: {
    id: "addATag"
  },
  addNewRow: {
    id: "addNewRow"
  },
  addNewTable: {
    id: "addNewTable"
  },
  categories: {
    id: "categories"
  },
  clear: {
    id: "clear"
  },
  close: {
    id: "close"
  },
  copiedToClipboard: {
    id: "copiedToClipboard"
  },
  copyToClipboard: {
    id: "copyToClipboard"
  },
  deleteRow: {
    id: "deleteRow"
  },
  deleteTable: {
    id: "deleteTable"
  },
  description: {
    id: "description"
  },
  editname: {
    id: "editgen.name"
  },
  editorLeaveWarning: {
    id: "editorLeaveWarning"
  },
  entries: {
    id: "entries"
  },
  entriesPerPage: {
    id: "entriesPerPage"
  },
  exit: {
    id: "exit"
  },
  generators: {
    id: "editgen.generators"
  },
  hideRunWindow: {
    id: "hideRunWindow"
  },
  invalidgenerator: {
    id: "editgen.invalid"
  },
  isLoading: {
    id: "isLoading"
  },
  newgenerator: {
    id: "editgen.newgenerator"
  },
  next: {
    id: "next"
  },
  path: {
    id: "path"
  },
  previous: {
    id: "previous"
  },
  resultPattern: {
    id: "resultPattern"
  },
  runGenerator: {
    id: "runGenerator"
  },
  save: {
    id: "save"
  },
  showRunWindow: {
    id: "showRunWindow"
  },
  switchToCode: {
    id: "switchToCode"
  },
  switchToForm: {
    id: "switchToForm"
  },
  tables: {
    id: "tables"
  },
  validate: {
    id: "validate"
  },
  validgenerator: {
    id: "editgen.valid"
  },
});



// WEBPACK FOOTER //
// ./src/Containers/generators/EditGenerator/translations.js